
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic02On as ObiLogic02OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-02-on.js';
 
 
 

 
 export const ObiLogic02On = createComponent({
   react: React,
   tagName: 'obi-logic-02-on',
   elementClass: ObiLogic02OnElement,
   events: {
     
   }
  });
 
 